module.exports = __webpack_public_path__ + "fonts/SourceSansPro-ExtraLightItalic.542b437a.ttf";